import React from 'react';
import { useReadingTime } from 'react-hook-reading-time';

import Icon from './Icon';

export default function ArticleTime({ article }) {
  const { minutes } = useReadingTime(
    article?.childMarkdownRemark?.rawMarkdownBody
  );
  return (
    <>
      {minutes && (
        <div className="article-time">
          <Icon icon="MdAccessTime" additionalClassNames="--left" />
          <p className="body --x-small --margin-bottom-null">{minutes} min</p>
        </div>
      )}
    </>
  );
}
